export default {"src":"/_next/static/media/order.461f6557.svg","height":16,"width":16};